// extracted by mini-css-extract-plugin
export default {"container":"non-academic-activity_container__lnB3u","title":"non-academic-activity_title__23uDq","tableContainer":"non-academic-activity_tableContainer__3CE3y"};